<template>
  <v-card>
    <v-card-title>
      Užívatelia ({{ count }})

      <v-spacer/>

      <Create
          @init="init()"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init()"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.name"
                        :error-messages="errors.Filters && errors.Filters.name"
                        :outlined="true"
                        :dense="true"
                        label="Meno"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.email"
                        :error-messages="errors.Filters && errors.Filters.email"
                        :outlined="true"
                        :dense="true"
                        label="E-mail"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.phone"
                        :error-messages="errors.Filters && errors.Filters.phone"
                        :outlined="true"
                        :dense="true"
                        label="Telefón"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.type"
                        :error-messages="errors.Filters && errors.Filters.type"
                        :outlined="true"
                        :dense="true"
                        label="Typ"
                        :items="$store.getters['register/getUserType']"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th
                          class="fixed"
                      >
                        <a
                            @click="setOrder($store.state.register.User.Filter.order['name'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.User.Filter.order['name'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.User.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Meno
                        </a>
                      </th>

                      <th>
                        E-mail
                      </th>

                      <th>
                        Telefón
                      </th>

                      <th>
                        Typ
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="users.length > 0"
                    >
                      <tr
                          v-for="User in users"
                          :key="User.id"
                      >
                        <td
                            class="fixed"
                        >
                          {{ User.name }}
                        </td>

                        <td>
                          {{ User.email }}
                        </td>

                        <td>
                          {{ User.phone }}
                        </td>

                        <td>
                          {{ $store.state.register.User.type[User.type].text }}
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <Update
                              :id="User.id"
                              @init="init()"
                          />

                          &nbsp;

                          <Delete
                              :id="User.id"
                              @init="init()"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="5"
                            class="text-center"
                        >
                          Nenašli sa žiadni užívatelia.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getUserFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage()"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage()"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Users from '@/services/users'

  import Create from '@/components/Users/Create'
  import Update from '@/components/Users/Update'
  import Delete from '@/components/Users/Delete'

  export default {
    name: 'Users',
    components: {
      Create,
      Update,
      Delete
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        users: [],
        params: {
          Filters: {
            name: '',
            email: '',
            phone: '',
            type: ''
          },
          order: this.$store.state.register.User.Filter.order['name'].value,
          by: this.$store.state.register.User.Filter.by['ASC'].value,
          limit: this.$store.state.register.User.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Užívatelia'
      }
    },
    beforeMount() {
      this.params = {
        ...this.params,
        ...Qs.parse(QueryTypes.parseObject(this.$route.query))
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.loadData()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.User.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.User.Filter.by['DESC'].value

            break

          case this.$store.state.register.User.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.User.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.loadData()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.loadData()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.loadData()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.loadData()
      },
      loadData() {
        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Users
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.users = response.data.data.users

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
